<template>
    <hr class="divider py-2 m-0" />
</template>

<style lang="scss" scoped>
    .divider {
        border-top: 1px solid #e5e5e5;
    } 
</style>